<script setup lang="ts">
import TableEmptyText from '@/components/texts/TableEmptyText.vue';
</script>

<template>
  <TableEmptyText
    :class="$style.dispatchSectionEmptyText"
    data-testid="dispatchSectionEmptyText"
  >
    No job selected. Use the panel to choose a job
  </TableEmptyText>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchSectionEmptyText {
}
</style>
